import styled from 'styled-components';

interface ContainerProps {
  'data-size': number;
}

export const SpotContainer = styled.div<ContainerProps>`
  position: relative;
  width: ${(props): number => props['data-size']}px;
  height: ${(props): number => props['data-size']}px;
  line-height: 0;
`;

export const FavIconContainer = styled.div<ContainerProps>`
  position: absolute;
  z-index: 10;
  right: -10%;
  bottom: -10%;
  width: ${(props): number => props['data-size']}px;
  height: ${(props): number => props['data-size']}px;
`;
